import { useContext } from "react";
import { ErrorProcessingContext } from "@/contexts/ErrorProcessingProvider";

export function useErrorProcessing() {
  const context = useContext(ErrorProcessingContext);

  if (!context) {
    throw new Error(
      "useErrorProcessing must be used within an ErrorProcessingProvider",
    );
  }

  return context;
}
